<template>
  <layout-basic>
    <v-container>
      <section class="container-small banner-text">
        <v-row>
          <v-col cols="12" md="12">
            <div class="privay-content">
              <p>
                <b><span>Improve Privacy Policy</span></b>
              </p>

              <p>
                <i><span>Updated: October 2026</span></i>
              </p>

              <p>
                <b><span>Summary</span></b>
              </p>

              <p>
                <span
                  >This Privacy Policy tells you what to expect when we collect
                  personal information. We are Improve Productions Limited, a
                  company registered in England and Wales with Company Number
                  (‘We, Us, Our’) and our registered office is: Space City, Dock,
                  75 Exploration Drive, Leicester, LE4 5NU. Our Data Protection Officer can
                  be contacted at:</span
                >
              </p>

              <p>
                <span
                  >Space City, Dock, 75 Exploration Drive, Leicester, LE4 5NU
</span>
              </p>

              <p>
                <span
                  >If at any time you are concerned or have questions about how
                  we might be handling your data, please reach out to our Data
                  Protection Officer at&nbsp;info@improve.online
                </span>
              </p>

              <p>
                <b
                  ><span
                    >IF YOU DO NOT ACCEPT AND AGREE WITH OUR PRIVACY POLICY THEN
                    YOU MUST NOT ACCESS OR USE IMPROVE OR THE SERVICE.</span
                  ></b
                >
              </p>

              <p>
                <span
                  >Improve Productions Limited (“Improve”, &quot;We&quot;, “Us”
                  and “Our”) always remain fully committed to the protection of
                  your and your Users’ privacy. The information contained in
                  this policy has been published to inform you of the way in
                  which any Personal Data (as defined below) you provide us with
                  or we collect from you will be used. Please read this
                  information carefully in order to fully understand how we
                  treat such Personal Data.</span
                >
              </p>

              <p>
                <span
                  >Please read this policy in conjunction with the&nbsp;End User
                  Licence Agreement&nbsp;for Improve (the “EULA”). When you
                  access or use Improve, you agree to our privacy policy and you
                  consent to our collection, storage, use and disclosure of your
                  Personal Data for the purpose of making Improve and/or the
                  Service available to you, in accordance with this policy. Any
                  capitalised terms not defined in this policy shall have the
                  same meanings given to them in the EULA.</span
                >
              </p>

              <p>
                <span
                  >We will collect, store, use and disclose Personal Data in
                  accordance with all applicable laws relating to the protection
                  of Personal Data, including the EU Data Protection Directive
                  95/46/EC, the EU General Data Protection Regulation 2016/679,
                  the EU ePrivacy Directive 2002/58/EC as amended by Directive
                  2009/136/EC, as amended or superseded from time to time, and
                  any national implementing legislation (“Data Protection
                  Laws”).</span
                >
              </p>

              <p>
                <span
                  >For the purpose of Data Protection Laws, in relation to any
                  Personal Data you or any Users submit to our platform, you
                  will be the data controller and we will be a data processor of
                  such Personal Data.</span
                >
              </p>

              <p>
                <b><span>PERSONAL DATA WE MAY OBTAIN FROM YOU</span></b>
              </p>

              <p>
                <span
                  >“Personal Data” means any information relating to an
                  identified or identifiable natural person; an identifiable
                  person is one who can be identified, directly or indirectly,
                  in particular by reference to an identifier such as a name, an
                  identification number, an online identifier or to one or more
                  factors specific to the physical, physiological, genetic,
                  mental, economic, cultural or social identity of that natural
                  person.</span
                >
              </p>

              <p>
                <span
                  >We may obtain and use the following Personal Data about you
                  and anyone you chose to add to our platform:</span
                >
              </p>

              <ul style="margin-top:0in" type="disc">
                <li>
                  <span
                    >Any correspondence we have with you and your Users should
                    you or your Users contact us.</span
                  >
                </li>
                <li>
                  <span
                    >Data you or your Users provide when you fill out forms on
                    our Website, including but not limited to data you provide
                    when you register to become a user of the Service.</span
                  >
                </li>
                <li>
                  <span
                    >Any data and information you or your user provide to us in
                    respect of our delivery of any service you have procured
                    from Improve.</span
                  >
                </li>
                <li>
                  <span
                    >Data and information you or your Users submit or upload to
                    Improve or the Service, including employee data (which may
                    include, among other things, names, email addresses of
                    Users).</span
                  >
                </li>
                <li>
                  <span
                    >Details of transactions made by you through the
                    Website.</span
                  >
                </li>
                <li>
                  <span
                    >Responses to optional research surveys we ask you or Users
                    to complete.</span
                  >
                </li>
                <li>
                  <span
                    >Details of your or your Users’ visits to our Website, which
                    includes without limitation location and traffic data,
                    weblogs, resources you access and other communication
                    data.</span
                  >
                </li>
              </ul>

              <p>
                <span
                  >You will be submitting and providing Client Data which may
                  contain Personal Data (and potentially Sensitive Personal Data
                  of Users and third parties. “Sensitive Personal Data” means
                  any data revealing racial or ethnic origin, political
                  opinions, religious or philosophical beliefs, or trade union
                  membership, genetic or biometric data, data concerning health,
                  data concerning sex life or sexual orientation and data
                  concerning the commission or alleged commission of any
                  offence.</span
                >
              </p>

              <p><span>You represent and warrant that you</span></p>

              <p style="text-indent:-.5in">
                <span
                  ><span style='font:7.0pt "Times New Roman"'
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                  >i.<span style='font:7.0pt "Times New Roman"'
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span></span
                ><span
                  >have the right to transfer such Personal Data (including
                  Sensitive Personal Data, if applicable) to us for the purpose
                  of receiving the Service; and</span
                >
              </p>

              <p style="text-indent:-.5in">
                <span
                  ><span style='font:7.0pt "Times New Roman"'
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                  >ii.<span style='font:7.0pt "Times New Roman"'
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span></span
                ><span
                  >are solely responsible for obtaining all required consents,
                  authorisations and permissions from such Users and third
                  parties and providing all required notifications to such Users
                  and third parties (where applicable) to enable you to provide
                  such information to us and to grant to us the rights set forth
                  in this privacy policy and the EULA. It is your responsibility
                  to ensure that all such Users and third parties are aware of
                  and accept the terms of this policy and that you have obtained
                  explicit and informed consent of Users to our processing any
                  of their Sensitive Personal Data in accordance with this
                  policy and the EULA. You may not provide us with any Client
                  Data or other information containing Personal Data of Users or
                  third parties unless and until you have obtained all necessary
                  consents, authorisations and permissions to do so.</span
                >
              </p>

              <p>
                <span
                  >You agree to indemnify us in accordance with Clause 14 of the
                  EULA for any claims made by any Users arising from any
                  unauthorised access or accidental loss, damage, corruption or
                  disclosure of Client Data arising from or in connection with
                  your and/ or our use or disclosure of Client Data.</span
                >
              </p>

              <p>
                <b><span>COOKIES AND SIMILAR TECHNOLOGIES</span></b>
              </p>

              <p>
                <span
                  >Our servers record technical information about the device used
                  to reach our Website and Service, such as its IP address, browser
                  type and operating system. We use it to run, secure and support
                  the Website and Service.</span
                >
              </p>

              <p>
                <span
                  >Cookies are small files a website stores in your browser; local
                  and session storage work in a similar way. We ask for your choice
                  before we use any of them that is not strictly necessary. You can
                  accept all, reject all, or choose analytics and videos
                  separately (visitor insights only come with accept all), and you can change
                  your choice at any time with the "Cookie settings" link at the
                  foot of every page of our Website, and on the sign up and sign
                  in pages of our platform. Your choice is stored once for all of
                  our websites on improve.online.</span
                >
              </p>

              <ul style="margin-top:0in" type="disc">
                <li>
                  <b><span>Strictly necessary.</span></b
                  ><span
                    >&nbsp;Needed to run the Website and Service, for example to
                    remember your cookie choice, to keep you signed in, and to
                    complete a purchase you have started. These do not need your
                    consent.</span
                  >
                </li>
                <li>
                  <b><span>Analytics, only with your consent.</span></b
                  ><span
                    >&nbsp;We use Google Analytics 4 to understand how visitors use
                    our Website and the sign up and sign in pages of our platform:
                    which pages are visited, how visitors arrived, which buttons and
                    links they use, which forms are started, sent or turned back
                    (the names of the fields only, never what was typed), what is
                    looked for in the site search (never anything that looks like an
                    email address or phone number), and which plans are viewed and
                    which bookings and purchases are completed. If analytics was allowed
                    when you bought, we keep the random identifier Google Analytics
                    gave your browser with your order, and if you pay by bank
                    transfer our servers report the purchase to Google Analytics
                    with it when your payment arrives, so that it is counted with
                    your visit. Nothing that names you or your company is sent.
                    Nothing is measured once you are signed in to the platform. We
                    remove email addresses and other personal details from page addresses
                    before anything is sent, we do not use Google signals or any
                    advertising features, and Google keeps this data for 14
                    months. Google may process it outside the United Kingdom,
                    under the safeguards in its data processing terms.</span
                  >
                </li>
                <li>
                  <b><span>Videos, only with your consent.</span></b
                  ><span
                    >&nbsp;Some pages show videos hosted by YouTube (Google) and
                    Synthesia. They load only once you allow videos, or when you
                    choose to load one, and those providers may then set their own
                    cookies, under their own privacy policies.</span
                  >
                </li>
                <li>
                  <b><span>Visitor insights, only if you accept all.</span></b
                  ><span
                    >&nbsp;If you choose "Accept all" on our Website, we tell
                    Popcorn, the customer relationship system used by Peritus
                    Learning, which pages of our Website you view. Popcorn uses the
                    IP address of your visit to see which organisation it comes
                    from, and if you arrived from a link in a Popcorn email, which
                    of its email contacts the visit belongs to; that contact is
                    remembered in your browser for later visits. We remove email
                    addresses and other personal details from page addresses before
                    anything is sent, keeping only campaign tags, and nothing is
                    sent from our buy pages. Nothing is sent if you choose "Reject
                    all" or save your own choices, and you can withdraw at any time
                    with the "Cookie settings" link, which also forgets the
                    remembered contact. Peritus Learning is responsible for the
                    information Popcorn collects.</span
                  >
                </li>
              </ul>

              <p>
                <span
                  >We do not use advertising cookies, and we do not sell your
                  browsing data. Apart from visitor insights above, we do not share
                  it with anyone for marketing.</span
                >
              </p>

              <p><span>The cookies and storage we use:</span></p>

              <table
                border="0"
                cellspacing="0"
                cellpadding="0"
                style="background:white;border-collapse:collapse"
              >
                <thead>
                  <tr>
                    <td width="200" style="width:150.0pt;padding:.75pt .75pt .75pt .75pt">
                      <p><b><span>Name</span></b></p>
                    </td>
                    <td style="padding:.75pt .75pt .75pt .75pt">
                      <p><b><span style="color:black">Provider and purpose</span></b></p>
                    </td>
                    <td style="padding:.75pt .75pt .75pt .75pt">
                      <p><b><span style="color:black">Kept for</span></b></p>
                    </td>
                  </tr>
                </thead>
                <tr>
                  <td width="200" style="width:150.0pt;padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">improve_consent_v2</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Improve. Remembers your cookie choice, once for all of our websites on improve.online (strictly necessary).</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">6 months</span></p>
                  </td>
                </tr>
                <tr>
                  <td width="200" style="width:150.0pt;padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">_ga, _ga_&lt;id&gt;</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Google Analytics. Tells visits apart and keeps each visit together (analytics, only with your consent).</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">13 months after your last visit</span></p>
                  </td>
                </tr>
                <tr>
                  <td width="200" style="width:150.0pt;padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">improve_purchase_uuid (session storage)</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Improve. Completes a purchase you have started (strictly necessary).</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Until you close the browser tab</span></p>
                  </td>
                </tr>
                <tr>
                  <td width="200" style="width:150.0pt;padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">improve_purchase_summary (session storage)</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Improve. Holds the plan and price of a card purchase you have started, so that Google Analytics can count it once it is paid. Nothing in it identifies you (analytics, only with your consent).</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Until the purchase completes, or you close the browser tab</span></p>
                  </td>
                </tr>
                <tr>
                  <td width="200" style="width:150.0pt;padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">token, vuex and settings entries (local storage)</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Improve. Keeps you signed in to our platform and remembers your settings there, such as searches, views and course progress (strictly necessary).</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Your sign in until you sign out; settings until you clear them in your browser</span></p>
                  </td>
                </tr>
                <tr>
                  <td width="200" style="width:150.0pt;padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">refPopcornContactId (local storage)</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Popcorn, for Peritus Learning. Remembers the Popcorn email contact you arrived from, so that later visits are linked to it. Only stored if you arrived from a Popcorn email (visitor insights, only if you accept all).</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Until you withdraw your choice or clear it in your browser</span></p>
                  </td>
                </tr>
                <tr>
                  <td width="200" style="width:150.0pt;padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Cookies set by YouTube and Synthesia</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Google and Synthesia. Play the embedded videos (videos, only with your consent).</span></p>
                  </td>
                  <td style="padding:.75pt .75pt .75pt .75pt">
                    <p><span style="color:black">Set by each provider</span></p>
                  </td>
                </tr>
              </table>

              <p>
                <span
                  >For how Google uses data from sites that use its services, see&nbsp;<a
                    href="https://policies.google.com/technologies/partner-sites"
                    target="_blank"
                    rel="noopener"
                    >https://policies.google.com/technologies/partner-sites</a
                  >. If you pay by card, you pay on Stripe's checkout page, which
                  sets its own cookies under Stripe's privacy policy. You can also
                  block or delete cookies in your browser settings, but some parts
                  of the Website or Service may then not work.</span
                >
              </p>

              <p>
                <b><span>WHERE WE STORE PERSONAL DATA</span></b>
              </p>

              <p>
                <span
                  >The Personal Data we obtain from you and your Users
                  (including, without limitation, Client Data) may be moved to
                  and stored at a destination within the European Economic Area
                  (&quot;EEA&quot;). Staff members operating within the EEA who
                  work for or on behalf of us may process this information. Such
                  staff members may, among other things, be involved in the
                  processing of payment details, the provision of support
                  services and the delivery of your and your Users’ request(s)
                  for us to provide the Service.</span
                >
              </p>

              <p>
                <span
                  >Without limiting the foregoing, you agree that Personal Data
                  we obtain from you and your Users (including, without
                  limitation, Client Data) may be processed by our service
                  providers based in, countries outside of the EEA for the
                  purposes of providing you with the Service. Such countries may
                  not have laws offering the same level of protection for
                  Personal Data as those inside the EEA; however where such
                  transfers of data occur, we will take steps to prevent the
                  transfer of Personal Data without adequate safeguards being
                  put in place and will ensure that your and your Users’
                  Personal Data collected in the EEA and transferred
                  internationally is afforded the same level of protection as it
                  would be inside the EEA. For further information on, or a copy
                  of, the adequate safeguards adopted by us for the
                  international transfer of Personal Data, please
                  email&nbsp;info@improve.online
                </span>
              </p>

              <p>
                <span
                  >We store the Personal Data you and your Users provide us with
                  on our secure servers. In the event of us giving you or your
                  Users (or you/they choosing) a password which grants you/them
                  access to specific areas within our Website or Service, it
                  remains your/their responsibility to maintain the
                  confidentiality of this password. This includes the
                  responsibility to refrain from sharing your/their password
                  with other parties.</span
                >
              </p>

              <p>
                <span
                  >As the transmission of data via the Internet cannot be
                  assumed completely secure, we cannot guarantee the security of
                  any of your or your Users’ data transmitted to our Website or
                  Service; you are therefore responsible for any risk associated
                  with such transmission. We will however at all times take all
                  reasonable steps to ensure the transmission of your and your
                  Users’ data is executed as securely as possible, and upon
                  receipt of your/their data we will continue at all times to
                  enforce strict security procedures and features in an attempt
                  to prevent any unauthorised access.</span
                >
              </p>

              <p>
                <b><span>HOW WE PROTECT YOUR PERSONAL DATA</span></b>
              </p>

              <p>
                <span
                  >We will take reasonable steps to maintain appropriate
                  technical and organizational measures to protect the Personal
                  Data you provide to us against accidental or unlawful
                  destruction, loss, alteration, unauthorised disclosure of, or
                  access to your Personal Data.</span
                >
              </p>

              <p>
                <b><span>HOW WE USE YOUR PERSONAL DATA</span></b>
              </p>

              <p>
                <span
                  >The Personal Data we hold about you and your Users may be
                  used in any of the following ways:</span
                >
              </p>

              <ul style="margin-top:0in" type="disc">
                <li>
                  <span
                    >To provide you and your Users with the Service, including
                    administration and management of your account.</span
                  >
                </li>
                <li>
                  <span
                    >To allow you to upload, store and access Client Data.</span
                  >
                </li>
                <li>
                  <span
                    >To enable Users to access certain aspects of Improve and
                    limited Client Data pertinent to themselves.</span
                  >
                </li>
                <li>
                  <span>To provide you and Users with user support.</span>
                </li>
                <li><span>To moderate your account.</span></li>
                <li>
                  <span
                    >For research and analytics purposes (for example, to
                    improve the quality of the Service).</span
                  >
                </li>
                <li>
                  <span
                    >To ensure security for you, the Users, our staff and other
                    users of the Service.</span
                  >
                </li>
                <li>
                  <span
                    >To comply with applicable Laws, court orders, government
                    and law enforcement agencies’ requests.</span
                  >
                </li>
                <li>
                  <span
                    >To send you further information about our services for
                    which we think you may have an interest. This information
                    will be supplied only where you have given consent.</span
                  >
                </li>
                <li>
                  <span
                    >To send you further information about our services based on
                    a request we have received from you.</span
                  >
                </li>
                <li>
                  <span
                    >To fulfil the obligations we have in relation to any
                    contracts we have in place with you (including, without
                    limitation, the EULA).</span
                  >
                </li>
                <li>
                  <span
                    >To provide you with notification about any changes to the
                    Service.</span
                  >
                </li>
              </ul>

              <p>
                <span
                  >We will never supply your or your Users’ Personal Data to
                  third parties unless under the conditions stated beneath this
                  section of our privacy policy. Notwithstanding the foregoing,
                  you acknowledge and agree that we may aggregate and anonymise
                  your, and your Users, Personal Data (excluding, for the
                  avoidance of doubt, Sensitive Personal Data) and use and share
                  such aggregated and anonymised Personal Data with third
                  parties for statistical purposes and for the purpose of data
                  analytics, product development, and/or Service
                  improvement.</span
                >
              </p>

              <p>
                <b><span>DISCLOSURE OF YOUR INFORMATION</span></b>
              </p>

              <p>
                <span
                  >Disclosure of your and your Users’ Personal Data (including,
                  without limitation, Client Data) to third parties will only
                  occur in any of the following events:</span
                >
              </p>

              <ul style="margin-top:0in" type="disc">
                <li>
                  <span
                    >We sell or purchase any business or assets. In such case,
                    we may authorise the disclosure of your personal data to
                    prospective sellers or buyers of such business or
                    assets.</span
                  >
                </li>
                <li>
                  <span
                    >All or the substantial majority of our assets are sold to a
                    third party. In such case, your personal data may be one of
                    the transferred assets.</span
                  >
                </li>
                <li>
                  <span
                    >We are required to disclose your or your Users’ personal
                    data in order to fulfil any legal obligation, to enforce our
                    EULA, or to protect the property, rights or safety of
                    Improve, users of our services or others. In such case,
                    information may be exchanged with third party companies or
                    organisations in order to prevent fraud or reduce credit
                    risk.</span
                  >
                </li>
              </ul>

              <p>
                <span
                  >You acknowledge and agree that we may also disclose Personal
                  Data (including, without limitation, Client Data) with: (i)
                  our service providers involved in the provision, distribution,
                  delivery and support of the Service, including the storage of
                  any Client Data; (ii) fraud prevention agencies; (iii) law
                  enforcement agencies, regulators, courts and public
                  authorities; and (iv) emergency services.</span
                >
              </p>

              <p>
                <span
                  >Our service providers have to follow our express instructions
                  when processing the Personal Data you or your Users provide
                  and must have in place appropriate technical and
                  organisational security measures to safeguard such Personal
                  Data, and we do not allow them to use this information for
                  their own commercial purposes.</span
                >
              </p>

              <p>
                <b><span>YOUR RIGHTS</span></b>
              </p>

              <p>
                <span
                  >You retain the right to request us to refrain from processing
                  your data for the purposes of marketing. To exercise such
                  right, you may reply to any information we send you, detailing
                  your request that we refrain from sending any marketing
                  correspondence, or you can exercise this same right by
                  contacting us electronically via email
                  at&nbsp;info@improve.online.&nbsp;If at any time we intend to
                  use your data for such marketing purposes however, it is
                  standard practice for us to make you aware in advance of
                  collecting such data.</span
                >
              </p>

              <p>
                <span
                  >We may at times provide links on our Website to third party
                  websites, including without limitation those owned or managed
                  by our partner networks, affiliates or advertisers. These
                  websites have separate privacy policies, and we therefore
                  cannot accept any responsibility for the content. As such,
                  choosing to follow these links is a choice you make at your
                  own risk, and we advise that you check these websites'
                  individual privacy policies before submitting any personal
                  data.</span
                >
              </p>

              <p>
                <span
                  >You retain at all times the right to access / amend / delete
                  any Personal Data we hold about you or to exercise your right
                  of data portability or to object to, or restrict, the purposes
                  for which your Personal Data is processed on certain grounds.
                  You may exercise this right by making a request in accordance
                  with Data Protection Laws, by
                  emailing&nbsp;info@improve.online. You may also lodge a
                  complaint with the UK data protection regulator, the
                  Information Commissioner should you be dissatisfied with the
                  way that we handle your Personal Data.</span
                >
              </p>

              <p>
                <span
                  >You undertake to notify your Users of this privacy policy and
                  of their rights under the Data Protection Law. We will provide
                  you with reasonable assistance to enable you to comply and
                  respond to a request, query or complaint from a User in
                  relation to their Personal Data.</span
                >
              </p>

              <p>
                <b><span>HOW LONG WE KEEP PERSONAL DATA FOR</span></b>
              </p>

              <p>
                <span
                  >We will keep your and your Users’ Personal Data for the
                  duration of the Service and in accordance with your
                  instructions or for such periods as may be required by
                  law.</span
                >
              </p>

              <p>
                <b><span>CHANGES TO OUR PRIVACY POLICY</span></b>
              </p>

              <p>
                <span
                  >If at any time we make a change to this policy, we will
                  update this page to reflect such change. Where we feel it
                  appropriate, we will notify you by email, however we recommend
                  you review this page periodically to ensure you remain happy
                  with the latest version.</span
                >
              </p>

              <p>
                <b><span>QUESTIONS, COMMENTS AND GETTING IN TOUCH</span></b>
              </p>

              <p>
                <span
                  >We welcome any questions or comments in relation to this
                  privacy policy, and advise you to send any such
                  communication&nbsp;info@improve.online</span
                >
              </p>

              <p><span>&nbsp;</span></p>
            </div>
          </v-col>
        </v-row>
      </section>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
export default {
  name: 'PrivacyPolicy',
  metaInfo() {
    return {
      title: 'Privacy Policy | IMPROVE - Protecting Your Data & Privacy',
      meta: [
        // Meta Description
        { name: 'description', content: "Read IMPROVE's Privacy Policy to understand how we collect, store, and use your personal data securely. Contact our Data Protection Officer for any inquiries regarding data privacy.",},
        
        // Keywords
        { name: 'keywords', content: 'IMPROVE Privacy Policy, data protection, GDPR compliance, personal data usage, cookie policy, user data privacy, data controller, data processor' },
        
        // Open Graph
        { property: 'og:title', content: 'Privacy Policy | IMPROVE - Protecting Your Data & Privacy' },
        { property: 'og:description', content: 'Learn how IMPROVE protects your personal data in compliance with GDPR and other data protection laws. Find details about cookies, data storage, and your rights.' },
        { property: 'og:image', content: 'https://www.improve.online/static/SEO.png' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://www.improve.online/privacy-policy' },
        
        // Twitter Card Tags
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Privacy Policy | IMPROVE - Protecting Your Data & Privacy' },
        { name: 'twitter:description', content: 'IMPROVE is committed to safeguarding your data in compliance with GDPR. Learn about our privacy practices, cookies, and your rights as a user.' },
        { name: 'twitter:image', content: 'https://www.improve.online/static/SEO.png'},
      ],
      link: [
        // Canonical URL
        { rel: 'canonical', href: 'https://www.improve.online/privacy-policy' },
      ],
    };
  },
  components: {
    LayoutBasic,
  },
};
</script>

